import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PackingInputAppEnvService } from './packing-input-app.env.service';
import {
  TCartonCreationDetailsRequest,
  TCartonCreationDetailsResponse,
  TSnpCompleteCartonDetailsRequest,
  TCreateNewCartonRequest,
  TFetchCartonDetailsByBctxRequest,
  TFetchCartonDetailsByBctxResponse,
  TREQUEST_AutoFillAndCompleteCartonsRequest,
  TREQUEST_CartonCountInfoRequestDTO,
  TREQUEST_CompleteCartonPackingRequest,
  TREQUEST_GetCartonBCTXTransactionsListingRequest,
  TREQUEST_GetCartonDetailsRequest,
  TREQUEST_GetCartonGroupDetailsListingRequest,
  TREQUEST_GetCartonSelectionListingRequest,
  TREQUEST_GetCartonTransactionsListingRequest,
  TREQUEST_SavePackDetailsRequest,
  TREQUEST_StartCartonPackingRequest,
  TREQUEST_TotalWipRequestDTO,
  TREQUEST_list_of_bctx_mapping,
  TRESPONSE_CartonBCTXTransactionsListingResponse,
  TRESPONSE_CartonCountInfoResponse,
  TRESPONSE_CartonDetailsResponse,
  TRESPONSE_CartonGroupDetailsListingResponse,
  TRESPONSE_CartonSelectionListingResponse,
  TRESPONSE_AutoFillAndCompleteCartons,
  TRESPONSE_CartonTransactionsListingResponse,
  TRESPONSE_CompleteCartonPacking,
  TRESPONSE_PackingTemplateDTO,
  TRESPONSE_SavePackDetails,
  TRESPONSE_StartCartonPacking,
  TRESPONSE_TotalWipRequestDTO,
  TRESPONSE_list_of_bctx_mapping,
  TSnpSaveCartonDetailsRequest,
  TSnpCartonTractionResponse,
  TgetSnpCartonDetailRequest,
  TgetSnpCartonDetailResponse,
  TSnpCartonTransactionRequest,
} from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class PackingInputAppDataService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  constructor(public http: HttpClient, public packingInputAppEnvService: PackingInputAppEnvService) {}

  fetchPackingConfig(factoryId: string, isScanAndPack = false) {
    const url =
      this.packingInputAppEnvService.getEnvVar(isScanAndPack ? 'SNP_PACKING_CONFIG' : 'PACKING_CONFIG') + factoryId;
    return this.http.get<TRESPONSE_PackingTemplateDTO>(url, this.httpOptions);
  }

  getCartonCountInfo(payload: TREQUEST_CartonCountInfoRequestDTO, scanAndPack: boolean) {
    const url = scanAndPack
      ? this.packingInputAppEnvService.getEnvVar('CARTON_COUNT_INFO_SNP')
      : this.packingInputAppEnvService.getEnvVar('CARTON_COUNT_INFO');
    return this.http.post<TRESPONSE_CartonCountInfoResponse>(url, payload, this.httpOptions);
  }

  getCartonSelectionListing(payload: TREQUEST_GetCartonSelectionListingRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('CARTON_SELECTION_LISTING');
    return this.http.post<TRESPONSE_CartonSelectionListingResponse>(url, payload, this.httpOptions);
  }

  getCartonGroupDetailListing(payload: TREQUEST_GetCartonGroupDetailsListingRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('CARTON_GROUP_DETAIL_LISTING');
    return this.http.post<TRESPONSE_CartonGroupDetailsListingResponse>(url, payload, this.httpOptions);
  }

  startCartonFilling(payload: TREQUEST_StartCartonPackingRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('START_CARTON');
    return this.http.post<TRESPONSE_StartCartonPacking>(url, payload, this.httpOptions);
  }

  completeCarton(payload: TREQUEST_CompleteCartonPackingRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('COMPLETE_CARTON');
    return this.http.post<TRESPONSE_CompleteCartonPacking>(url, payload, this.httpOptions);
  }

  autoFillAndCompleteCartons(payload: TREQUEST_AutoFillAndCompleteCartonsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('AUTO_FILL_AND_COMPLETE_CARTONS');
    return this.http.post<TRESPONSE_AutoFillAndCompleteCartons>(url, payload, this.httpOptions);
  }

  savePacksDetail(payload: TREQUEST_SavePackDetailsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SAVE_PACKS');
    return this.http.post<TRESPONSE_SavePackDetails>(url, payload, this.httpOptions);
  }

  getCartonDetails(payload: TREQUEST_GetCartonDetailsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('CARTON_DETAIL_BY_ID');
    return this.http.post<TRESPONSE_CartonDetailsResponse>(url, payload, this.httpOptions);
  }

  getTransactionListing(payload: TREQUEST_GetCartonBCTXTransactionsListingRequest, scanAndPack: boolean) {
    const url = scanAndPack
      ? this.packingInputAppEnvService.getEnvVar('SNP_BCTX_TRANSACTIONS')
      : this.packingInputAppEnvService.getEnvVar('TRANSACTION_LISTING');
    return this.http.post<TRESPONSE_CartonBCTXTransactionsListingResponse>(url, payload, this.httpOptions);
  }

  getTransactionCartonDetailListing(payload: TREQUEST_GetCartonTransactionsListingRequest, scanAndPack: boolean) {
    const url = scanAndPack
      ? this.packingInputAppEnvService.getEnvVar('SNP_CARTON_TRANSACTIONS')
      : this.packingInputAppEnvService.getEnvVar('TRANSACTION_CARTON_DETAIL');
    return this.http.post<TRESPONSE_CartonTransactionsListingResponse>(url, payload, this.httpOptions);
  }

  getTotalWipQty(payload: TREQUEST_TotalWipRequestDTO) {
    const url = this.packingInputAppEnvService.getEnvVar('TOTAL_WIP_QTY');
    return this.http.post<TRESPONSE_TotalWipRequestDTO>(url, payload, this.httpOptions);
  }

  getListOfBctxMapping(payload: TREQUEST_list_of_bctx_mapping) {
    const url = this.packingInputAppEnvService.getEnvVar('BCTX_MAPPING_LIST');
    return this.http.post<TRESPONSE_list_of_bctx_mapping>(url, payload, this.httpOptions);
  }

  // SCAN AND PACK

  fetchScanAndPackConfig(factoryId: string) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_PACKING_CONFIG') + factoryId;
    return this.http.get<TRESPONSE_PackingTemplateDTO>(url, this.httpOptions);
  }

  fetchCartonCreationDetails(payload: TCartonCreationDetailsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_CARTON_CREATION_DETAILS');
    return this.http.post<TCartonCreationDetailsResponse>(url, payload, this.httpOptions);
  }

  fetchCartonDetailsByBctx(payload: TFetchCartonDetailsByBctxRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_CARTONS_BY_BCTX');
    return this.http.post<TFetchCartonDetailsByBctxResponse>(url, payload, this.httpOptions);
  }

  createCarton(payload: TCreateNewCartonRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_CREATE_CARTON');
    return this.http.post<TFetchCartonDetailsByBctxResponse>(url, payload, this.httpOptions);
  }

  getSnpCarton(payload: TgetSnpCartonDetailRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('GET_CARTON_SNP');
    return this.http.post<TgetSnpCartonDetailResponse>(url, payload, this.httpOptions);
  }

  saveScanAndPackCarton(payload: TSnpSaveCartonDetailsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_SAVE_CARTON');
    return this.http.post<TFetchCartonDetailsByBctxResponse>(url, payload, this.httpOptions);
  }

  completeScanANdPackCarton(payload: TSnpCompleteCartonDetailsRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_COMPLETE_CARTON');
    return this.http.post<TFetchCartonDetailsByBctxResponse>(url, payload, this.httpOptions);
  }

  getSnpCartonTransaction(payload: TSnpCartonTransactionRequest) {
    const url = this.packingInputAppEnvService.getEnvVar('SNP_CARTON_TRANSACTIONS');
    return this.http.post<TSnpCartonTractionResponse>(url, payload, this.httpOptions);
  }
}
